import { StatusCode } from "api/protocols";
import { PostLoyaltyProgramStep1 } from "api/rpc/2024-04/facilityAdmin/customer/loyalty";
import { ButtonNew as Button } from "components/buttonNew";
import Card from "components/card/Card";
import FormLayout from "components/form/FormLayout";
import Input from "components/form/input";
import TextField from "components/form/textField/TextField";
import Page from "components/page/Page";
import SelectNew from "components/select/SelectNew";
import { useAppDispatch } from "hooks/redux";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import { loadLoyaltyProgram } from "redux/actions/facility";
import { showError, showSuccess } from "redux/actions/ui";
import { ILoyaltyProgram } from "redux/reducers/models/loyalty";

interface IState {
    name: string;
    type: "points_based" | "tier_based";
    welcome_text: string;
    
}

export default function LoyaltyProgramStep1() {
    const {t} = useTranslation();
    const dispatch = useAppDispatch();
    const history = useHistory();
    const [state, setState] = useState<IState>({
        name: "",
        type: "points_based",
        welcome_text: "",
    });

    async function handleStep1() {
        if (!state?.name || !state?.type) {
            dispatch(showError(t("Program name and type are required")));
            return;
        }
        const res = await PostLoyaltyProgramStep1({...state, welcome_text: state?.welcome_text ? state?.welcome_text : undefined}, true);
        if (res?.status !== StatusCode.OK){
            dispatch(showError(t("Error setting up program")));
            return;
        }
        dispatch(showSuccess(t("Successfully completed step 1")));
        //Set the program in redux
        void dispatch(loadLoyaltyProgram(res?.data?.loyalty_program as ILoyaltyProgram));
        if (state?.type === "points_based") {
            history.push("/admin/settings/loyalty-program/points/step-2");
        } else {
            history.push("/admin/settings/loyalty-program/tiers/step-2");
        }
    }

    return (
        <Page
        narrow
        title={t("Step 1: Set Up Your Program")}
        breadcrumbs={[
            {
              prefix: true,
              label: t("Back"),
              url: "/admin/settings/loyalty-program",
            },
          ]}
        >
        <Card title={t("Program Details")} subtitle={t("Setup your program details")}>
            <Card.Section>
                <FormLayout>
                    <FormLayout.Group>
                        <Input label={t("Program Name")} value={state?.name ?? ""} onChange={e => setState(prev => ({...prev, name: e.target.value}))} placeholder={t("Program Name")} maxLength={100}/>
                        <SelectNew
                            id="program_type"
                            label={t("Program Type")}
                            options={[
                                { label: t("Points-based"), id: "points_based" },
                                { label: t("Tier-based"), id: "tier_based" },
                            ]}
                            onChange={value => setState(prev => ({...prev, type: value}))}
                            value={state.type}
                            tooltip={<div>
                                <p className="font-semibold">{t("Tier-based program:")}</p> <p>{t("Set levels for customers to hit each tier to unlock better perks or earn rates.")}</p>
                                 <br/> 
                                 <p className="font-semibold">{t("Points-based program:")}</p> <p>{t("Earn points for spending or actions and redeem them for rewards.")}</p></div>}
                            />
                    </FormLayout.Group>
                    <FormLayout.Group>
                        <TextField 
                            label={(t("Customer-Facing Description"))}
                            value={state?.welcome_text}
                            maxLength={300}
                            rows={4}
                            placeholder={t("Add a short description customers will see. Ex: Unlock free rounds and member-only perks.")}
                            characterCountBottom
                            onChange={e => setState(prev => ({...prev, welcome_text: e.target.value}))}
                            />
                        </FormLayout.Group>
                </FormLayout>
            </Card.Section>
        </Card>
        <div className="loyalty-button-container">
        <Button type="primary" size="medium" onClick={handleStep1}>{t("Next")}</Button>
        </div>
        </Page>
    );
}